import React, { useState, useEffect } from 'react';
import { styled, LazyImage, SvgIcon, Tag, ButtonChevron } from '@teko/ui';
import { __rest } from 'tslib';
import { t } from './i18n.es.js';

const StyledProductGifts = styled.div `
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;
const Label = styled.div(({ theme }) => `
  font-size: 0.6875rem;
  color: ${theme.colors.gray130};
`);
const ImageWrapper = styled.div `
  margin: 0 0.2rem;
  width: 30px;
  height: 30px;
`;
const PromotionIcon = styled.div `
  width: 28px;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  margin: 0 0.2rem;
  box-sizing: content-box;
`;
const ProductGifts = ({ label, images = [], className, voucherCount = 0, }) => (React.createElement(StyledProductGifts, { className: className },
    React.createElement(Label, null, label),
    images.map((image, index) => (React.createElement(ImageWrapper, { key: index },
        React.createElement(LazyImage, { src: image.src, height: 30, width: 30, border: true, borderRadius: 4, alt: image.alt, contain: true })))),
    voucherCount > 0 &&
        Array.from(Array(voucherCount).keys()).map((i) => {
            return (React.createElement(PromotionIcon, { key: i },
                React.createElement(SvgIcon, { name: "promotion", size: 16, color: "#1435c3" })));
        })));

const StyledProductName = styled.div(({ maxLines = 3 }) => `
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${maxLines};
  font-size: 13px;
`);
const StyledTag = styled(Tag)(({ color }) => `
  margin-right: 0.2rem;
  background-color: ${color};
  padding: 1px 0.4rem;
  font-size: 13px;
  font-weight: 400;
  padding: 2px 8px;
  border-radius: 4px;
`);
const RemainingProduct = styled.div `
  color: #d9852b;
  font-size: 0.75rem;
  margin-top: 2px;
  margin-bottom: 8px;
  line-height: 1rem;
`;
const ProductName = (_a) => {
    var { name, status, needManageStock, totalAvailableByStocks, isFlashSelling = false, tag } = _a, props = __rest(_a, ["name", "status", "needManageStock", "totalAvailableByStocks", "isFlashSelling", "tag"]);
    const NameTag = StyledProductName.withComponent(tag ? tag : 'div');
    return (React.createElement(React.Fragment, null,
        React.createElement(NameTag, Object.assign({}, props, { maxLines: totalAvailableByStocks > 0 && totalAvailableByStocks < 5 ? 2 : 3 }),
            status && (React.createElement(StyledTag, Object.assign({}, Object.assign(Object.assign({}, status), { children: status.value, variant: 'primary' })))),
            name),
        !isFlashSelling &&
            needManageStock &&
            totalAvailableByStocks > 0 &&
            totalAvailableByStocks < 5 && (React.createElement(RemainingProduct, null, t('Chỉ còn {{totalAvailableByStocks}} sản phẩm', {
            totalAvailableByStocks,
        })))));
};

const Wrapper$2 = styled.div `
  margin-top: 8rem;
  text-align: center;
`;
const Text = styled.div `
  margin-top: 1.5rem;
  font-size: 1rem;
`;
const NoProductsFound = (_a) => {
    var { text = t('Không tìm thấy sản phẩm nào'), show } = _a, props = __rest(_a, ["text", "show"]);
    const NoProductImage = 'https://firebasestorage.googleapis.com/v0/b/mongcaifood.appspot.com/o/no-products-found.png?alt=media&token=2f22ae28-6d48-49a7-a36b-e1a696618f9c';
    if (!show)
        return null;
    return (React.createElement(Wrapper$2, Object.assign({}, props),
        React.createElement(LazyImage, { width: 200, height: 200, contain: true, src: NoProductImage }),
        React.createElement(Text, null, text)));
};

const Wrapper$1 = styled.div((props) => `
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${props.selected ? '#f5f5f5' : '#fff'};
    padding: 0.6rem;
    cursor: ${props.onClick ? 'pointer' : ''};
    &:hover {
      background-color: ${props.type !== 'search-suggestion' && '#f5f5f5'};
    }
  `);
const Title = styled.div `
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${(props) => props.numberOfLine};
  overflow: hidden;
  margin: 0 0.6rem;
  flex: 1;
`;
const ListTile = React.forwardRef((_a, ref) => {
    var { leading, title, trailing, numberOfLine = 1, onClick, onMouseEnter, type, selected = false } = _a, props = __rest(_a, ["leading", "title", "trailing", "numberOfLine", "onClick", "onMouseEnter", "type", "selected"]);
    return (React.createElement(Wrapper$1, Object.assign({ ref: ref, selected: selected, onMouseEnter: onMouseEnter }, props, { onClick: onClick, type: type }),
        leading,
        React.createElement(Title, { numberOfLine: numberOfLine }, title),
        trailing));
});
ListTile.displayName = 'ListTile';

const Wrapper = styled.div `
  position: relative;
`;
const StyledButtonChevron = styled(ButtonChevron) `
  background: #fff;
  width: 100%;
  border: 1px solid #e0e0e0;
  line-height: unset;
  &:hover {
    background: #f3f3f3;
    border: 1px solid #e0e0e0;
  }
`;
const DropdownMenu = styled.div `
  position: absolute;
  width: 100%;
  top: 2rem;
  left: 0;
  z-index: 1000;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  overflow: hidden;
`;
const MiniDropdown = (_a) => {
    var { text, children } = _a, props = __rest(_a, ["text", "children"]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [endDelay, setEndDelay] = useState(false);
    useEffect(() => {
        if (dropdownOpen) {
            setTimeout(() => {
                setEndDelay(true);
            }, 200);
        }
        else {
            setEndDelay(false);
        }
    }, [dropdownOpen, endDelay]);
    return (React.createElement(Wrapper, Object.assign({ onMouseEnter: () => setDropdownOpen(true), onMouseLeave: () => setDropdownOpen(false) }, props),
        React.createElement(StyledButtonChevron, { direction: dropdownOpen ? 'up' : 'down' }, text),
        dropdownOpen && endDelay && (React.createElement(DropdownMenu, { onClick: () => setDropdownOpen(false) }, children))));
};

export { ListTile as L, MiniDropdown as M, NoProductsFound as N, ProductGifts as P, ProductName as a };
